export default [
  {
    path: "/pos",
    meta: { title: "POS Devices" },
    name: "POS",
    component: () => import("@/modules/pos/views/PosList.vue"),
  },
  {
    path: "/pos/edit/:id",
    meta: { title: "POS Booking Details" },
    name: "ViewPos",
    component: () => import("@/modules/pos/views/Pos.vue"),
  },
];
